import type { ViewConfig } from "@kontextwerk/control-web-frame"

export const workspaceConfig = {
  viewId: "organization",
  subview: { id: "work-order", parentPageId: "workOrders", parentTabTitle: "Aufträge" },
} satisfies NonNullable<ViewConfig["workspace"]>
